<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		TipoEvento,
		API, 
		cabecalhoPadraoRequisicao,
		limparLocalStorage, 
		TextoFeedback, 
		enviarDadosFormulario,
		carregarEditorTexto } from '../../utils';
	import TBox from '../templates/TBox.svelte';
	
	// The params prop contains values matched from the URL
	export let params = {}

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let titulo, alocacao, modalidade, unidade, totalBolsas, cursoEAD;

	//  AGENDA 2030
	let conheceAgenda2030;

	let areasConhecimento = [];
	let modalidades = [];
	let unidades = [];
	let informacosAPICache = null;
	let flagVisibilidade = false;
	let editorCarregado = false;
	let projeto = {};
	let corpoPatch = {};
	let dataInicialCadastro = "";
	let dataFinalCadastro = "";
	let listaODS = [];
	let listaODSCadastrada = [];
	let formulario;

	onMount(async () => {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando projeto ...',
		});
		
		const resposta = await fetch(API(`projetos/${params.codigo}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("#/painel");
		});

		const { dados } = await resposta.json();
		// console.log(dados);

		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
		areasConhecimento = informacosAPICache.areas_conhecimento;
		modalidades = informacosAPICache.modalidades;
		unidades = informacosAPICache.unidades;

		projeto = dados;

		dataInicialCadastro = informacosAPICache.prazos?.cadastro_projetos_inicio ?? '[#Erro - necessário limpar cache]';
		dataFinalCadastro = informacosAPICache.prazos?.cadastro_projetos_fim ?? '[#Erro - necessário limpar cache]';

		listaODS = informacosAPICache.ods;
		formulario = document.getElementById('formAtualizacaoProjeto');

		if (projeto === undefined) {
			replace('#/projeto-inexistente');
		} else {
			titulo = projeto?.titulo;
			alocacao = projeto?.alocacao_const;
			modalidade = projeto?.modalidade_const;
			unidade = projeto?.unidade_const;
			listaODSCadastrada = projeto?.lista_ods_possui_relacao ?? [];

			// se o preve_inclusao_alunos_ead for = null significa que o coordenador ainda não preencheu (terceiro estado)
			if (projeto?.preve_inclusao_alunos_ead === 1)
				cursoEAD = true;
			if (projeto?.preve_inclusao_alunos_ead === 0)
				cursoEAD = false;

			// o mesmo para conhece_agenda2030
			if (projeto?.conhece_agenda2030 === 1)
				conheceAgenda2030 = true;
			if (projeto?.conhece_agenda2030 === 0)
				conheceAgenda2030 = false;
		}

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		totalBolsas = projeto.total_bolsas;
	});

	const carregarEditor = () => {
		flagVisibilidade = true;
		
		if (editorCarregado == false)
			carregarEditorTexto('editor-descricao-projeto', projeto.descricao, true, (valor) => editorCarregado = valor);
	}

	async function submeterFormulario(event) {
		// Obtenha todos os checkboxes marcados dentro do formulário
		const checkboxesMarcados = Array.from(formulario.querySelectorAll('input[type="checkbox"]:checked'));

		// Obtenha os valores dos checkboxes marcados
		const valoresCheckboxesMarcados = checkboxesMarcados.map((checkbox) => checkbox.value);

		// verificar se editor foi carregado, indicando que houve alteração de dados da descrição do projeto, caso contrário, não enviar descricao para o patch
		if (editorCarregado) {
			corpoPatch = JSON.stringify({
				id: projeto.id,
				titulo: titulo, 
				alocacao: alocacao, 
				modalidade: modalidade, 
				unidade: unidade, 
				total_bolsas: totalBolsas,
				preve_inclusao_alunos_ead: cursoEAD,
				conhece_agenda2030: conheceAgenda2030,
				ods_marcados: valoresCheckboxesMarcados,
				descricao: editor.getData()
			});
		} else {
			corpoPatch = JSON.stringify({
				id: projeto.id,
				titulo: titulo, 
				alocacao: alocacao, 
				modalidade: modalidade,
				unidade: unidade,
				total_bolsas: totalBolsas,
				preve_inclusao_alunos_ead: cursoEAD,
				conhece_agenda2030: conheceAgenda2030,
				ods_marcados: valoresCheckboxesMarcados,
			});
		}

		let operacao = enviarDadosFormulario('PATCH', dispatch, replace, 'projetos', corpoPatch, 
			'Projeto atualizado com sucesso.', 
			'#/painel/projetos',
			'#/projetos'
		);

		if (operacao) limparLocalStorage(false, false, false, true);
	}

	const marcacaoODSCadastrada = (idODS) => {
		return listaODSCadastrada.some(ods => ods.id === idODS);
	}
</script>

<TBox 
	titulo="Atualização" 
	subtitulo="Formulário de atualização de projeto" 
	largura="12" 
	deslocamento="0" 
	icone="projeto">
	
	<div class="notification is-danger is-light">
		Prazo para realizar alterações no projetos: de <strong>{dataInicialCadastro}</strong> até <strong>{dataFinalCadastro}</strong>.
	</div>

	<form method="post" on:submit|preventDefault={submeterFormulario} id="formAtualizacaoProjeto">
		<small>Título do Projeto:</small>
		<div class="columns">
			<div class="column">
				<div class="field">
					<input 
						bind:value={titulo}
						name="titulo" 
						type="text" 
						placeholder="Título do projeto" 
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<small>Alocação:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={alocacao} name="alocacao" required>
						{#each Object.entries(areasConhecimento) as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select> 
				</div>
			</div>
			<div class="column">
				<small>Unidade:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={unidade} name="unidade" required>
						{#each Object.entries(unidades) as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>
		
		<div class="columns">
			<div class="column">
				<small>Modalidade:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select disabled>
						<option>{projeto.modalidade}</option>
					</select>
				</div>
			</div>

			<div class="column is-3">
				<small>Total de bolsas:</small>
				<div class="field">
					<input 
						bind:value={totalBolsas}
						name="totalBolsas" 
						type="number" 
						min="0"
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>





		<div class="columns">
			<div class="column">
				<div class="control">
					<p>O projeto prevê a inclusão de estudantes dos cursos de graduação EAD?</p>

					<label class="radio">
						<input type="radio" bind:group={cursoEAD} value={true} required>
						Sim
					</label>
					<label class="radio">
						<input type="radio" bind:group={cursoEAD} value={false}>
						Não
					</label>
				</div>
			</div>
		</div>

		<hr style="margin: auto; width: 50%" class="mb-3">

		<div class="columns">
			<div class="column">
				<p class="is-size-4 has-text-primary">Agenda 2030 da ONU</p>
			</div>
		</div>

		<div class="columns has-background-white-ter mx-1 borda-arredondada-10">
			<div class="column">
				<div class="control">
					<p>Você conhece a Agenda 2030 da ONU e seus 17 Objetivos de Desenvolvimento Sustentável (ODS)?</p>

					<label class="radio">
						<input type="radio" bind:group={conheceAgenda2030} value={true} required>
						Sim
					</label>
					<label class="radio">
						<input type="radio" bind:group={conheceAgenda2030} value={false}>
						Não
					</label>
				</div>
			</div>
		</div>

		<div class="columns has-background-white-ter mx-1 mt-3 borda-arredondada-10">
			<div class="column">
				<div class="control">
					<p class="mb-2">Seu projeto relaciona-se ou tem potencial para ser relacionado a algum(s) dos 17 Objetivos de Desenvolvimento Sustentável (ODS) da AGENDA 2030 da ONU de modo mais especifico? se sim, qual ou quais? <small>Para saber mais, acesse: (Fonte: <a href="https://brasil.un.org/pt-br/sdgs" target="_blank">https://brasil.un.org/pt-br/sdgs</a>)</small></p>
					<p class="mb-3">Caso não selecione uma ou mais das opções abaixo, será entendido como <strong>Não, meu projeto não tem nem poderia ser relacionado a nenhum ODS</strong>.</p>
					<p class="has-text-centered">&middot;&middot;&middot;</p>

					{#each listaODS as { id, descricao }}
						<br>
						<label class="checkbox">
							<input type="checkbox" value={id} checked={marcacaoODSCadastrada(id)}>
							<span>{@html descricao.replace(/^(.*?) - /, "<span class='has-text-weight-semibold'>$1</span> -")}</span>
						</label>
					{/each}
				</div>
			</div>
		</div>

		<hr style="margin: auto; width: 50%" class="mb-3">





		<div class="columns">
			<div class="column">
				<div class="notification is-info is-light">Clique no botão abaixo para abrir o editor de textos para realizar as alterções desejados no conteúdo do projeto. Não é possível alterar a modalidade do projeto.</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<button class="button is-info is-medium is-fullwidth py-6 {flagVisibilidade == true ? 'is-hidden' : ''}" on:click|preventDefault={carregarEditor}>Clique aqui para carregar o editor da descrição do projeto</button>
				<textarea name="descricao" class="content editor-descricao-projeto {flagVisibilidade == false ? 'is-hidden' : ''}"></textarea>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column">
				<p class="control">
					<a href="#/painel" class="button is-black is-medium is-outlined is-fullwidth">Painel</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Alterar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>